import axios from 'axios';
import apisUrls from '../urls';

const deleteAppPackageApi = (id) => {
  
  return axios.delete(`${apisUrls?.deleteAppPackage}?package_id=${id}`);
};

export default deleteAppPackageApi;
